import { useState, useEffect } from 'react';
import { _SelectLabourByPorductionOrder } from '../../../../core/services/dataBean/EntityCatalogVdos';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { BasicTable, MASK_MONEY } from '../../../theme/Component/BasicTable';
import { Modal } from '../../../theme/Component/Modal';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
    idProductionOrder?: any;
    productionOrderDate?: any
}

export const SelectLabourByPorductionOrder = ({ idSelector, onChange, label, returnType = "ID", render, idProductionOrder, productionOrderDate }: Props) => {

    const { instance, lista, setLista } = useDataBean(_SelectLabourByPorductionOrder)
    const [id, setID] = useState(null);

    const modal = useModal("Labor/Actividad", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDLabour == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {

        instance.getLabourCatalogByProductionOrder(idProductionOrder, productionOrderDate).then(
            (resp: any) => {
                if (resp) {
                    console.log();

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDLabour', visible: true },
        { title: 'Orden de Labor', property: 'LabourOrder', visible: true },
        { title: 'Tipo de Actividad', property: 'LabourTypeName', visible: true },
        { title: 'Recurso', property: 'ProductionResourceName', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },

        { title: 'Centro de Costo', property: 'CostingCenterStr', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Unidades', property: 'LabourTimeUnitName', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Costo Unitario', property: 'UnitaryCost', visible: true, mask: MASK_MONEY },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Labor/Actividad"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDLabour); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}